import { reactive } from "vue";

const defaultConfirmDialogState = {
  visible: false,
  title: "提示",
  message: "",
  type: "warning",
  confirmButtonText: "确定",
  cancelButtonText: "取消",
  closeOnClickModal: true,
  width: "420px",
  zIndex: 30000,
};

export const confirmDialogState = reactive({ ...defaultConfirmDialogState });

let activeResolve = null;
let activeReject = null;

function resetConfirmDialogState() {
  Object.assign(confirmDialogState, defaultConfirmDialogState);
}

function settleConfirmDialog(confirmed) {
  const resolve = activeResolve;
  const reject = activeReject;

  activeResolve = null;
  activeReject = null;
  confirmDialogState.visible = false;
  resetConfirmDialogState();

  if (confirmed) {
    resolve?.();
    return;
  }

  reject?.(new Error("cancel"));
}

export function openConfirmDialog(message, title = "提示", options = {}) {
  if (confirmDialogState.visible) {
    return Promise.reject(new Error("A confirmation dialog is already open."));
  }

  return new Promise((resolve, reject) => {
    activeResolve = resolve;
    activeReject = reject;

    Object.assign(confirmDialogState, defaultConfirmDialogState, options, {
      visible: true,
      title,
      message,
    });
  });
}

export function confirmActiveDialog() {
  settleConfirmDialog(true);
}

export function cancelActiveDialog() {
  settleConfirmDialog(false);
}
